import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const SINCE_INCEPTION = 'Since Inception';
const EN_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const FR_MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];
const IT_MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
];

// Shared by the French-language regions (fr-FR and fr-CH) so the two cannot drift apart.
const FR_TRANSLATION = {
  months: FR_MONTHS,
  '1Y': '1A',
  '3Y': '3A',
  '5Y': '5A',
  '10Y': '10A',
  YTD: 'Depuis le début de l’année',
  PERFORMANCE_LINE_GRAPH: 'Graphique de performance',
  PERFORMANCE_TABLES: 'Tableaux de performance',
  INC: 'Depuis le lancement',
  FROM: 'Du',
  TO: 'Au',
  DATE: 'Date',
  PERCENTAGE: 'Performance (%)',
  ANNUALISED_RETURN: 'Performance annualisée',
  CUMULATIVE_PERFORMANCE: 'Performance cumulée',
  PRODUCT: 'Produit',
  CUMROR: 'Depuis la création',
  CUMRORANN: 'Depuis la création',
  AS_OF: 'Au',
  // Shown on the line-graph tab.
  DISCLAIMER:
    'Les performances passées ne constituent pas un indicateur fiable des performances futures. Les marchés pourraient évoluer très différemment à l’avenir. Elles peuvent vous aider à évaluer la manière dont le fonds a été géré dans le passé et à comparer ses performances à celles de son indice de référence. Ce graphique présente la performance annuelle du fonds, exprimée en pourcentage de gain ou de perte, par rapport à son indice de référence.',
  // Shown on the three table tabs.
  DISCLAIMER_TABLES:
    "Les performances passées ne constituent pas un indicateur fiable des performances futures. Les marchés pourraient évoluer très différemment à l'avenir. Elles peuvent vous aider à évaluer la manière dont le fonds a été géré dans le passé et à comparer ses performances à celles de son indice de référence. Ce tableau présente la performance du fonds par rapport à son indice de référence.",
  INCEPTION_DATE: "Date de lancement de l'indice : {inceptionDt}",
  CALENDAR_PERFORMANCE: 'Performance calendaire',
  PERFORMANCE_TITLE: 'Performance',
  DATA_UNAVAILABLE:
    'Les données sont actuellement indisponibles. Veuillez réessayer ultérieurement.',
  UCITS_FOOTNOTE_BENCHMARK_ONLY:
    'La performance de l’indice de référence est affichée en {{idxCurrency}}.',
  UCITS_FOOTNOTE_HEDGED_SHARECLASS:
    'Il s’agit d’une classe d’actions couverte contre le risque de change. La performance est affichée en {{fundCurrency}} et la performance de l’indice de référence en {{idxCurrency}}.',
  UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
    'Les performances de la catégorie de parts sont exprimées en {{fundCurrency}} et celles de l’indice de référence sont également exprimées en {{idxCurrency}}.',
};

i18n.use(initReactI18next).init({
  lng: 'en', // Set the default language
  fallbackLng: 'en', // Fallback to English if translation is missing
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  resources: {
    en: {
      translation: {
        months: EN_MONTHS,
        '1D': '1D',
        '1W': '1W',
        '1M': '1M',
        '3M': '3M',
        '6M': '6M',
        '1Y': '1Y',
        '3Y': '3Y',
        '5Y': '5Y',
        '10Y': '10Y',
        YTD: 'YTD',
        PQ: 'Prev Qtr',
        PQ2: 'Prev 2 Qtr',
        PQ3: 'Prev 3 Qtr',
        PQ4: 'Prev 4 Qtr',
        PCY: 'Previous Year',
        Q1: 'Q1',
        Q2: 'Q2',
        Q3: 'Q3',
        Q4: 'Q4',
        INC: SINCE_INCEPTION,
        CUSTOM: 'Custom',
        PRICE: 'Price',
        MARKET: 'Market',
        G10K: 'Growth of Hypothetical 10K',
        AS_OF: 'As Of',
        CLOSE: 'Close',
        VOLUME: 'Volume',
        HIGH: 'High',
        LOW: 'Low',
        AVERAGE: 'Average',
        PREMIUM: 'Premium',
        DISCOUNT: 'Discount',
        COMPARISON: 'Comparison',
        NAME: 'Name',
        WEIGHT_PCT: 'Weight (%)',
        SECTORS: 'SECTORS',
        WEIGHT_OF_TOP_N_PREFIX: 'Weight of Top',
        WEIGHT_OF_TOP_N_SUFFIX: 'Within Portfolio',
        WEIGHT_HOLD: 'Weight of holding (%)',
        SECT_HOLD: 'Sector Holdings',
        SECT_HOLD_TOP: 'Top holdings in sector',
        PERFORMANCE_LINE_GRAPH: 'Performance Line Graph',
        PERFORMANCE_TABLES: 'Performance Tables',
        ANNUALISED_RETURN: 'Annualised Return',
        CUMULATIVE_PERFORMANCE: 'Cumulative Performance',
        CALENDAR_PERFORMANCE: 'Calendar Performance',
        PERFORMANCE_TITLE: 'Performance',
        PRODUCT: 'Product',
        MTD: '1M',
        MOS3ROR: '3M',
        MOS6ROR: '6M',
        CUMROR: 'Since Inception',
        CUMRORANN: 'Since Inception',
        DISCLAIMER:
          'Past performance is not a reliable indicator of future performance. Markets could develop very differently in the future. It can help you to assess how the fund has been managed in the past and compare it to its benchmark. This chart shows the fund’s performance as the percentage loss or gain per year against its benchmark.',
        INCEPTION_DATE: 'Index performance inception date: {inceptionDt}',
        PERCENTAGE: 'Percentage',
        FROM: 'FROM',
        TO: 'TO',
        DATE: 'Date',
        UCITS_FOOTNOTE_BENCHMARK_ONLY: 'Benchmark performance displayed in {{idxCurrency}}.',
        UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
          'Share Class performance displayed in {{fundCurrency}} and Benchmark performance displayed in {{idxCurrency}}.',
        UCITS_FOOTNOTE_HEDGED_SHARECLASS:
          'This is a hedged share class, performance displayed in {{fundCurrency}} and Benchmark performance displayed in {{idxCurrency}}.',
      },
    },
    'en-GB': {
      translation: {
        months: EN_MONTHS,
        '1D': '1D',
        '1W': '1W',
        '1M': '1M',
        '3M': '3M',
        '6M': '6M',
        '1Y': '1Y',
        '3Y': '3Y',
        '5Y': '5Y',
        '10Y': '10Y',
        YTD: 'YTD',
        PQ: 'Prev Qtr',
        PQ2: 'Prev 2 Qtr',
        PQ3: 'Prev 3 Qtr',
        PQ4: 'Prev 4 Qtr',
        PCY: 'Prev Year',
        Q1: 'Q1',
        Q2: 'Q2',
        Q3: 'Q3',
        Q4: 'Q4',
        INC: SINCE_INCEPTION,
        CUSTOM: 'Custom',
        PRICE: 'Price',
        MARKET: 'Market',
        G10K: 'Growth of Hypothetical 10K',
        AS_OF: 'As Of',
        CLOSE: 'Close',
        VOLUME: 'Volume',
        HIGH: 'High',
        LOW: 'Low',
        AVERAGE: 'Average',
        PREMIUM: 'Premium',
        DISCOUNT: 'Discount',
        COMPARISON: 'Comparison',
        NAME: 'Name',
        WEIGHT_PCT: 'Weight (%)',
        SECTORS: 'SECTORS',
        WEIGHT_OF_TOP_N_PREFIX: 'Weight of Top',
        WEIGHT_OF_TOP_N_SUFFIX: 'Within Portfolio',
        WEIGHT_HOLD: 'Weight of holding (%)',
        SECT_HOLD: 'Sector Holdings',
        SECT_HOLD_TOP: 'Top holdings in sector',
        DATA_UNAVAILABLE: 'Data is currently unavailable. Please try again later.',
        UCITS_FOOTNOTE_BENCHMARK_ONLY: 'Benchmark performance displayed in {{idxCurrency}}.',
        UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
          'Share Class performance displayed in {{fundCurrency}} and Benchmark performance displayed in {{idxCurrency}}.',
        UCITS_FOOTNOTE_HEDGED_SHARECLASS:
          'This is a hedged share class, performance displayed in {{fundCurrency}} and Benchmark performance displayed in {{idxCurrency}}.',
      },
    },
    'it-IT': {
      translation: {
        months: IT_MONTHS,
        '1D': '1G',
        '1W': '1S',
        '1M': '1M',
        '3M': '3M',
        '6M': '6M',
        '1Y': '1A',
        '3Y': '3A',
        '5Y': '5A',
        '10Y': '10A',
        YTD: 'YTD',
        PQ: 'Q1',
        PQ2: 'Q2',
        PQ3: 'Q3',
        PQ4: 'Q4',
        PCY: 'PREV YEAR',
        Q1: 'Q1',
        Q2: 'Q2',
        Q3: 'Q3',
        Q4: 'Q4',
        INC: "Dall'inizio",
        CUSTOM: 'Personalizzato',
        PRICE: 'Prezzo',
        MARKET: 'Mercato',
        G10K: 'Crescita di Ipotesi 10K',
        AS_OF: 'Al',
        CLOSE: 'Chiusura',
        VOLUME: 'Volume',
        HIGH: 'Alto',
        LOW: 'Basso',
        AVERAGE: 'Media',
        PREMIUM: 'Premio',
        DISCOUNT: 'Sconto',
        COMPARISON: 'Comparazione',
        NAME: 'Nome',
        WEIGHT_PCT: 'Peso (%)',
        SECTORS: 'settori',
        WEIGHT_OF_TOP_N_PREFIX: 'Peso della Top',
        WEIGHT_OF_TOP_N_SUFFIX: 'del portafoglio',
        WEIGHT_HOLD: 'Peso della conservazione (%)',
        SECT_HOLD: 'Aziende del settore',
        SECT_HOLD_TOP: 'Principali partecipazioni nel settore',
        PERFORMANCE_LINE_GRAPH: 'Grafico a linee sulla performance',
        PERFORMANCE_TABLES: 'Tabelle sulla performance',
        ANNUALISED_RETURN: 'Rendimento annualizzato',
        CUMULATIVE_PERFORMANCE: 'Performance cumulata',
        CALENDAR_PERFORMANCE: 'Performance di calendario',
        PERFORMANCE_TITLE: 'Performance',
        PRODUCT: 'Prodotto',
        MTD: '1M',
        MOS3ROR: '3M',
        MOS6ROR: '6M',
        CUMROR: 'DALL’AVVIO',
        CUMRORANN: 'DALL’AVVIO',
        DISCLAIMER:
          'La performance storica non è un’indicazione affidabile di quella futura. I mercati potrebbero evolversi in modo molto diverso in futuro. Può essere utile per valutare il modo in cui il fondo è stato gestito in passato e confrontarlo con il suo benchmark. Questo grafico mostra la performance del fondo in termini di perdita o guadagno percentuale annuo rispetto al suo benchmark.',
        INCEPTION_DATE: "Data di avvio della performance dell'indice: {inceptionDt}",
        PERCENTAGE: 'Percentuale',
        FROM: 'DA',
        TO: 'A',
        DATE: 'Data',
        UCITS_FOOTNOTE_BENCHMARK_ONLY: 'Performance del benchmark mostrata in {{idxCurrency}}.',
        UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
          'Performance della classe azionaria mostrata in {{fundCurrency}} e performance del benchmark mostrata in {{idxCurrency}}.',
        UCITS_FOOTNOTE_HEDGED_SHARECLASS:
          'La presente costituisce una classe azionaria con copertura; performance mostrata in {{fundCurrency}} e performance del benchmark mostrata in {{idxCurrency}}.',
      },
    },
    'de-DE': {
      translation: {
        '1D': '1T 1',
        '1W': '1W',
        '1M': '1M',
        '3M': '3M',
        '6M': '6M',
        '1Y': '10J',
        '3Y': '3J',
        '5Y': '5J',
        '10Y': '10J',
        YTD: 'Seit Jahresanfang',
        Q1: 'Q1',
        Q2: 'Q2',
        Q3: 'Q3',
        Q4: 'Q3',
        INC: 'Seit Auflage',
        CUSTOM: 'individuell',
        PRICE: 'Kurs',
        MARKET: 'Market',
        G10K: 'Wachstum von 10.000',
        AS_OF: 'per',
        CLOSE: 'Schluss',
        VOLUME: 'Volumen',
        HIGH: 'Hoch',
        LOW: 'Tief',
        AVERAGE: 'Durchschnitt',
        PREMIUM: 'Aufschlag',
        DISCOUNT: 'Abschlag',
        COMPARISON: 'Vergleich',
        NAME: 'Naam',
        WEIGHT_PCT: 'Gewicht',
        SECTORS: 'sectoren',
        WEIGHT_OF_TOP_N_PREFIX: 'Gewicht van Top',
        WEIGHT_OF_TOP_N_SUFFIX: 'binnen portfolio',
        WEIGHT_HOLD: 'Gewicht van de deelneming (%)',
        SECT_HOLD: 'Sectorbedrijven',
        SECT_HOLD_TOP: 'Topposities in secto',
        PERFORMANCE_LINE_GRAPH: 'Liniendiagramm zur Wertentwicklung',
        PERFORMANCE_TABLES: 'Tabellen zur Wertentwicklung',
        ANNUALISED_RETURN: 'Annualisierte Rendite',
        CUMULATIVE_PERFORMANCE: 'Kumulierte Wertentwicklung',
        CALENDAR_PERFORMANCE: 'Wertentwicklung im Kalenderjahr',
        PERFORMANCE_TITLE: 'Wertentwicklung',
        PRODUCT: 'Produkt',
        MTD: '1M',
        MOS3ROR: '3M',
        MOS6ROR: '6M',
        CUMROR: 'SEIT_AUFLEGUNG',
        CUMRORANN: 'SEIT_AUFLEGUNG',
        DISCLAIMER:
          'Die Wertentwicklung der Vergangenheit ist kein zuverlässiger Indikator für zukünftige Ergebnisse. Die Märkte könnten sich in Zukunft sehr unterschiedlich entwickeln. Die Informationen können Ihnen dabei helfen, die bisherige Verwaltung des Fonds zu beurteilen und ihn mit seiner Benchmark zu vergleichen. Diese Abbildung zeigt die Wertentwicklung des Fonds als prozentualen Verlust oder Gewinn pro Jahr im Vergleich zu seiner Benchmark.',
        INCEPTION_DATE: 'Wertentwicklung des Index seit Auflegung: {inceptionDt}',
        PERCENTAGE: 'Prozentsatz',
        FROM: 'VON',
        TO: 'BIS',
        DATE: 'Datum',
        UCITS_FOOTNOTE_BENCHMARK_ONLY:
          'Wertentwicklung der Benchmark angezeigt in {{idxCurrency}}.',
        UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
          'Wertentwicklung der Anteilsklasse angezeigt in {{fundCurrency}} und Wertentwicklung der Benchmark angezeigt in {{idxCurrency}}.',
        UCITS_FOOTNOTE_HEDGED_SHARECLASS:
          'Dies ist eine abgesicherte Anteilsklasse. Wertentwicklung angezeigt in {{fundCurrency}} und Wertentwicklung der Benchmark angezeigt in {{idxCurrency}}.',
      },
    },
    'fr-CA': {
      translation: {
        '1D': 'jour',
        '1W': '1 semaine',
        '1M': '1 mois',
        '3M': '3 mois',
        '6M': '6 mois',
        '1Y': '1 an',
        '3Y': '3 ans',
        '5Y': '5 ans',
        '10Y': '10 ans',
        YTD: 'Cumul annuel à ce jour',
        INC: 'Depuis la création',
        CUSTOM: 'Personnalisé',
        PRICE: 'Cours',
        MARKET: 'Marché',
        G10K: "Croissance d'une somme hypothétique de 10 000 $  ",
        AS_OF: 'au',
        CLOSE: 'FERMETURE',
        VOLUME: 'Volume',
        HIGH: 'Élevé',
        LOW: 'Faible',
        AVERAGE: 'Moyenne',
        PREMIUM: 'À prime',
        DISCOUNT: 'À escompte',
        COMPARISON: 'Comparaison',
        NAME: 'Nom',
        WEIGHT_PCT: 'Pondération',
        SECTORS: 'SECTEURS',
        WEIGHT_OF_TOP_N_PREFIX: 'Pondération des principaux',
        WEIGHT_OF_TOP_N_SUFFIX: 'titres du portefeuille',
        WEIGHT_HOLD: 'Pondération des placements',
        SECT_HOLD: 'Placements par secteurs',
        SECT_HOLD_TOP: 'Principaux placements par secteurs',
        PERFORMANCE_LINE_GRAPH: 'Graphique des performances',
        PERFORMANCE_TABLES: 'Tableau des performances',
        ANNUALISED_RETURN: 'Rendements annualisés',
        CUMULATIVE_PERFORMANCE: 'Performances cumulées',
        CALENDAR_PERFORMANCE: 'Performances calendaires',
        PERFORMANCE_TITLE: 'Performances',
        PRODUCT: 'Produit',
        MTD: '1M',
        MOS3ROR: '3M',
        MOS6ROR: '6M',
        CUMROR: 'DEPUIS LE DÉBUT',
        CUMRORANN: 'DEPUIS LE DÉBUT',
        DISCLAIMER:
          'Les performances passées ne constituent pas un indicateur fiable des performances futures. Les marchés peuvent évoluer de manière très différente à l’avenir. Ces informations permettent d’évaluer la façon dont le fonds a été géré par le passé et de le comparer à son indice de référence. Ce graphique présente la performance du fonds, exprimée en pourcentage de gain ou de perte par an, par rapport à son indice de référence.',
        INCEPTION_DATE: 'Date de début de la performance de l’indice : {inceptionDt}',
        PERCENTAGE: 'Pourcentage',
        FROM: 'DU',
        TO: 'AU',
        DATE: 'Date',
        UCITS_FOOTNOTE_BENCHMARK_ONLY:
          'La performance de l’indice de référence est indiquée en {{idxCurrency}}.',
        UCITS_FOOTNOTE_SHARECLASS_AND_BENCHMARK:
          'La performance de la part est indiquée en {{fundCurrency}} et celle de l’indice de référence en {{idxCurrency}}.',
        UCITS_FOOTNOTE_HEDGED_SHARECLASS:
          'Il s’agit d’une part couverte : la performance est indiquée en {{fundCurrency}} et celle de l’indice de référence en {{idxCurrency}}.',
        // Strings supplied for the French regions override the Canadian defaults.
        ...FR_TRANSLATION,
      },
    },
    'fr-FR': {
      translation: FR_TRANSLATION,
    },
    'fr-CH': {
      translation: FR_TRANSLATION,
    },
  },
});

export default i18n;
